import InfoPopover from "../infoPopover/infoPopover"
import { useLanguage } from "../../contexts/LanguageContext"

/**
 * Font family selector with live preview update.
 * Updates CSS custom property for real-time font preview in the interface.
 * @param {Object} props
 * @param {Object} props.element - Configuration element
 * @param {Object} props.parameters - Current parameters state
 * @param {Function} props.setParameters - Function to update parameters
 * @returns {JSX.Element}
 */
function FontFamily({ element, parameters, setParameters }) {
  const { t } = useLanguage()

  /**
   * Updates font family and applies it to the preview.
   * @param {Event} event
   */
  const setFont = event => {
    const newFont = event.target.value
    if (setParameters && element && parameters) {
      setParameters({ ...parameters, [element.id]: newFont })
      document.documentElement.style.setProperty("--preview-font-family", newFont)
    }
  }

  const resetFont = () => {
    if (setParameters && element && parameters) {
      setParameters({ ...parameters, [element.id]: element.default })
      document.documentElement.style.setProperty("--preview-font-family", element.default)
    }
  }

  return (
    <div className="row textEditor">
      <div className="col-5 d-flex justify-content-end align-items-center">
        {element?.label ? t(element.label) : element?.label}
        {element && <InfoPopover element={element} />}
      </div>
      <div className="col">
        {element && (
          <>
        <input type="text" id={`input-${element?.id}`} className="form-control" value={parameters?.[element?.id] || ""} onChange={setFont} />
            <div className="resetBloc" onClick={resetFont} data-testid="reset-button"></div>
          </>
        )}
      </div>
    </div>
  )
}

export default FontFamily
